
const NoMatch = () => {
    return (
        <div>Not Found</div>
    );
}

export default NoMatch;